import React from "react";
import {
  StyledFiltersSelected,
  StyledFilterChip,
} from "./FiltersSelected.styled";
import {
  FilterProps,
  FontWeightEnum,
  IconSizeEnum,
} from "../../types/AppTypes";
import { ReactComponent as CloseIcon } from "../../icons/close.svg";
import { ReactComponent as DeleteIcon } from "../../icons/bin.svg";
import { IconManager } from "../core/IconManager/IconManager";
import { BodyTyp, CaptionsTyp } from "../Typography/Typography";
import { RESET_FILTERS_LABEL } from "../../constants/Dictionary";
import { Link, LinkSizeEnum } from "../core/Link/Link";
import { Filter, FilterOption } from "../../types/api/filters.type";

type FiltersSelectedProps = {
  data: Filter[];
  filters: FilterProps[];
  setFilters: (filters: FilterProps[]) => void;
};

export function FiltersSelected({
  data,
  filters,
  setFilters,
}: FiltersSelectedProps) {
  const getFilterLabel = (key: string, value: string | number) => {
    const filter = data.find((filter: Filter) => filter.key === key);
    const option = filter?.options.find(
      (option: FilterOption) => option.value === value,
    );
    return option?.label ?? value;
  };

  const removeFilter = (key: string, value: string | number) => {
    const updatedFilters = filters
      .map((filter) => {
        if (filter.key === key) {
          return {
            ...filter,
            value: filter.value.filter((v) => v !== value),
          };
        }
        return filter;
      })
      .filter((filter) => filter.value.length > 0);

    setFilters(updatedFilters);
  };

  if (!filters?.length) return null;

  return (
    <StyledFiltersSelected>
      {filters.map((filter) =>
        filter.value.map((value) => {
          const filterInfo = getFilterLabel(filter.key, value);
          if (!filterInfo) return null;
          return (
            <StyledFilterChip key={`${filter.key}-${value}`}>
              <CaptionsTyp variant="2" fontWeight={FontWeightEnum.MEDIUM}>
                {filterInfo}
              </CaptionsTyp>
              <IconManager
                size={IconSizeEnum.SMALL}
                onClick={() => removeFilter(filter.key, value)}
              >
                <CloseIcon />
              </IconManager>
            </StyledFilterChip>
          );
        }),
      )}
      <div className="link-container">
        <Link
          icon={<DeleteIcon />}
          size={LinkSizeEnum.SMALL}
          onClick={() => setFilters([])}
        >
          <BodyTyp variant="1" fontWeight={FontWeightEnum.MEDIUM}>
            {RESET_FILTERS_LABEL}
          </BodyTyp>
        </Link>
      </div>
    </StyledFiltersSelected>
  );
}
